// validations/profileValidation.js
import * as Yup from "yup";

export const profileValidationSchema = Yup.object({
  name: Yup.string()
    .required("Full name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be less than 50 characters"),
  email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email address"),
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit mobile number"),
  pincode: Yup.string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit pincode"),
  address: Yup.string()
    .required("Address is required")
    .min(10, "Address must be at least 10 characters")
    .max(200, "Address must be less than 200 characters"),
});

export const bankValidationSchema = Yup.object({
  banking_name: Yup.string()
    .required("Account holder name is required")
    .min(3, "Name must be at least 3 characters")
    .max(50, "Name must be less than 50 characters"),
  bank_name: Yup.string()
    .required("Bank name is required")
    .min(2, "Bank name must be at least 2 characters")
    .max(100, "Bank name must be less than 100 characters"),
  account_no: Yup.string()
    .required("Account number is required")
    .matches(
      /^[0-9]{9,18}$/,
      "Please enter a valid account number (9-18 digits)",
    ),
  ifsc_code: Yup.string()
    .required("IFSC code is required")
    .matches(
      /^[A-Z]{4}0[A-Z0-9]{6}$/,
      "Please enter a valid IFSC code (e.g., SBIN0001234)",
    )
    .transform((value) => value.toUpperCase()),
  branch: Yup.string()
    .required("Branch name is required")
    .min(2, "Branch name must be at least 2 characters")
    .max(100, "Branch name must be less than 100 characters"),
  upi_id: Yup.string()
    .nullable()
    .test("valid-upi", "Please enter a valid UPI ID", (value) => {
      if (!value) return true;
      return /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{3,}$/.test(value);
    }),
});
